module.exports = {
  apiUrlProd: "https://console.kas.com.au/api",
  apiUrlDev: "https://console.kas.com.au/api",
  navBarTitle: process.env.REACT_APP_TITLE
};
